module.exports = __webpack_public_path__ + "/svg/eherkenning-logo.5b3d2dfe7f1135ce0b6a84f4f1ad6d4e.svg";